<template>
  <div class="index-page">
    <div class="section text-center">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: 'index'
};
</script>
<style>
.index-page {
  min-height: calc(100vh - 50px);
}
</style>
